/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.TERMINALS_RECEIVE]: (state, action) => {
            return reduce(
                action.payload.terminals,
                (memo, terminal) => {
                    const { id } = terminal;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[id] = terminal;
                    return memo;
                },
                state,
            );
        }
    },
);